import nBossConnection from 'modules/base/service/nBossConnection';

class DatasetService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'datasetControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} measurementId
	* @param {string} datasetName
	* @return {Promise<any>}
	*/
	createFromMeasurement(measurementId, datasetName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/createFromMeasurement`, { measurementId, datasetName })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new DatasetService();
